module.exports = __webpack_public_path__ + "img/certificate_ogr_421300118_00.b5087521.png";